export default {
  name: 'response-template',
  translationKey: 'response-template-module',
  routePrefix: 'response-template',
  routeNamePrefix: 'admin.response-template',
  directRoutesAvailable: false,
}
